import { styled } from 'theme'

export const StyledDefaultSettingsNavigation = styled.div`
  background-color: white;
`
